// extracted by mini-css-extract-plugin
module.exports = {"container":"gaHs9S8qfJGcGsbVGFIhv","restaurantsList":"_10u_psjZ397L-PQxuVNHZq","item":"_2EY7ZWWX3g_nFuVIAhI02w","dot":"tTgtJq2P0D2JB1N9fWLEs","input":"_3b1y1qNLjBnKj_ePiMwZ7H"};